import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';
import { getActiveSpace, getActiveSpaceId } from 'spaces/store/selectors';


export const getAllFolderTrees = (state) => state.folders.folderTreeBySpaceId;

export const getFolderTreeBySpaceId = (state, spaceId) =>
  state.folders.folderTreeBySpaceId[spaceId] || [];

export const getSpaceIdsLoadingFolderTree = (state) => state.folders.spaceIdsLoadingFolderTree;

export const getFoldersById = (state) => state.entities.folders;

export const getEditingFolderId = (state) => state.folders.editingFolderId;

export const getFolderIdsBySpaceId = (state) => state.folders.folderIdsBySpaceId;

export const getActiveFolderId = (state) => state.folders.activeFolderId;

export const getDocumentCountByFolderId = (state) => state.folders.documentCountByFolderId;

export const getActiveFolderChildrenIsLoading = (state) =>
  state.folders.activeFolderChildrenIsLoading;

export const getActiveFolderTree = createSelector(
  [getActiveSpace, getAllFolderTrees],
  (space, folderTrees) =>
    ((folderTrees && space && folderTrees[space.id]) ? folderTrees[space.id] : []),
);

export const getActiveSpaceFolderTreeIsLoading = createSelector(
  [getActiveSpaceId, getSpaceIdsLoadingFolderTree],
  (spaceId, spaceIdsLoadingFolderTree) =>
    spaceIdsLoadingFolderTree.includes(parseInt(spaceId, 10)),
);

export const getAnyFolderTreeIsLoading = createSelector(
  [getSpaceIdsLoadingFolderTree],
  (spaceIdsLoadingFolderTree) => spaceIdsLoadingFolderTree.length > 0,
);

export const getActiveFolder = createSelector(
  [getFoldersById, getActiveFolderId],
  (folders, id) => folders[id] || null,
);

export const getActiveFolderChildrenIds = (state) => state.folders.activeFolderChildrenIds;

export const getActiveFolderChildren = createSelector(
  [getFoldersById, getActiveFolderChildrenIds],
  (folders, ids) => ids.map((id) => folders[id]),
);

export const getEditingFolder = createSelector(
  [getFoldersById, getEditingFolderId],
  (folders, id) => folders[id],
);


export const getActiveSpaceFolderSelectOptions = createSelector(
  [getFolderIdsBySpaceId, getFoldersById, getActiveSpaceId],
  (folderIdsBySpaceId, foldersById, spaceId) =>
    (folderIdsBySpaceId[spaceId] && folderIdsBySpaceId[spaceId].length > 0
      ? [
        { value: null, label: 'Documents' },
        ...folderIdsBySpaceId[spaceId].map((id) => ({ value: id, label: foldersById[id].name })),
      ]
      : []),
);


export const getActivePathString = createSelector(
  [getFoldersById, getActiveFolder],
  (folders, activeFolder) => ((folders && activeFolder && activeFolder.pathIds)
    ? activeFolder.pathIds.reduce((pathString, id) => `${pathString}${folders[id].name}/`, '')
    : ''),
);

export const getActivePathStringWithSpace = createSelector(
  [getActiveSpace, getActivePathString],
  (space, pathString) => (space ? `${space.name}/${pathString}` : ''),
);


export const getBreadcrumbPathsForFolderId = createCachedSelector(
  [getFoldersById, (state, folderId) => folderId],
  (foldersById, folderId) => {
    if (!foldersById[folderId]) {
      return null;
    }
    const folder = foldersById[folderId];
    if (!folder.parent || !foldersById[folder.parent]) {
      return null;
    }
    const parentFolder = foldersById[folder.parent];
    const pathFolders = parentFolder.pathIds.map((id) => foldersById[id] && foldersById[id]);
    return pathFolders
      .filter((folder) => !!folder)
      .map((folder) => ({
        path: folder.route,
        label: folder.name,
      }));
  },
)((foldersById, folderId) => folderId || 'loading');
// 'loading' is only a dummy to avoid errors before all documentIds are fully loaded
